import { render } from "./AdminMagazine.vue?vue&type=template&id=c013efe6"
import script from "./AdminMagazine.vue?vue&type=script&lang=js"
export * from "./AdminMagazine.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__